<div class="pos-relative">
    <button class="w-12 flex flex-justify-between p-a b-a b-col-52"
            (click)="toggle([toggleGroup, 1])">
        <p class="p1 col-12">{{'Select your region' | translate}}<span class="col-2">*</span></p>
        <i class="icon-chevron is-down inline-flex"
           [style.fontSize.px]="18"
           [toggleClassBy]="[toggleGroup, 1]"
           [toggleClass]="'is-up !is-down'">
        </i>
    </button>

    <div class="hide-up-container pos-absolute m-t-2 z-3 w-12">
        <div class="hide-up ng-hide ng-hide-animate bg-col-w b-a"
             [toggleClass]="'!ng-hide'"
             [toggleClassBy]="[toggleGroup, 1]">
            @for (item of sites; track $index) {
            <div class="_link">
                <button class="flex flex-middle flex-justify-left p-a-2 m-a-2"
                        (click)="selectCurrency(item)">
                    <multisite-flag class="flex m-r-1"
                                    [siteId]="item.siteId"
                                    [dropDownFlag]="true"></multisite-flag>
                    &nbsp;
                    <p class="p-l-1-m p-l-1-s p1">{{item.currency_symbol}} {{item.currency}} -
                        {{item.name}}</p>
                </button>
            </div>
            }
        </div>
    </div>
</div>